import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GalleryItem } from '../hooks/useGallery';
import Lightbox from './Lightbox';

interface ProductCardProps {
  item: GalleryItem;
  onDelete?: (id: string) => void;
  isAdmin?: boolean;
}

const ProductCard: React.FC<ProductCardProps> = ({ item, onDelete, isAdmin = false }) => {
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <div className="group relative overflow-hidden rounded-lg bg-white shadow-md transition-transform duration-300 hover:scale-105">
        <div
          className="aspect-square overflow-hidden cursor-pointer"
          onClick={() => setIsLightboxOpen(true)}
        >
          <img
            src={item.imageUrl}
            alt={item.title}
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-110"
          />
        </div>
        
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
            <h3 className="text-xl font-serif mb-2">{item.title}</h3>
            <p className="text-sm text-gray-200">{item.description}</p>
            <span className="inline-block mt-2 px-3 py-1 bg-accent/80 rounded-full text-xs">
              {t(`gallery.filter.${item.category.toLowerCase()}`)}
            </span>
          </div>
        </div>

        {isAdmin && onDelete && (
          <button
            onClick={() => onDelete(item.id)}
            className="absolute top-2 right-2 p-2 bg-red-500 text-white rounded-full opacity-0 transition-opacity duration-300 group-hover:opacity-100 hover:bg-red-600"
            aria-label={t('common.delete')}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </button>
        )}
      </div>

      <Lightbox
        isOpen={isLightboxOpen}
        onClose={() => setIsLightboxOpen(false)}
        imageUrl={item.imageUrl}
        title={item.title}
        description={item.description}
      />
    </>
  );
};

export default ProductCard; 